import { useNavigate, useParams } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import PmocForm from './PmocForm'
import { usePmocDetalhe, usePmocUpdate } from '../../hooks/usePmoc'
import { extractApiError } from '../../lib/extractApiError'
import type { PMOCCreateInput } from '../../types'
import styles from '../_shared/CrudPage.module.css'

export default function PmocEditarPage() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const detalhe = usePmocDetalhe(id)
  const update = usePmocUpdate(id)

  if (detalhe.isLoading) return <div className={styles.loading}>Carregando PMOC...</div>
  if (detalhe.error || !detalhe.data) {
    return <div className={styles.empty}>PMOC não encontrado.</div>
  }
  const pmoc = detalhe.data

  if (pmoc.status !== 'rascunho') {
    return (
      <div className={styles.page}>
        <header className={styles.header}>
          <div>
            <button
              className={styles.backBtn}
              type="button"
              onClick={() => navigate(`/pmoc/${id}`)}
            >
              ← Voltar
            </button>
            <h1 className={styles.title}>Edição não disponível</h1>
          </div>
        </header>
        <p className={styles.empty}>
          Apenas PMOCs em status <strong>rascunho</strong> podem ser editados (este está
          em <strong>{pmoc.status}</strong>).
        </p>
        <p>Para alterar, duplique o PMOC e edite a nova versão.</p>
      </div>
    )
  }

  async function handleSubmit(data: PMOCCreateInput) {
    try {
      await update.mutateAsync(data)
      notifications.show({ color: 'green', message: 'PMOC atualizado.' })
      navigate(`/pmoc/${id}`)
    } catch (err) {
      notifications.show({
        color: 'red',
        title: 'Falha ao salvar',
        message: extractApiError(err, 'Erro ao salvar PMOC.'),
      })
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate(`/pmoc/${id}`)}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>Editar PMOC v{pmoc.versao}</h1>
        </div>
      </header>
      <PmocForm
        initial={pmoc}
        onSubmit={handleSubmit}
        isLoading={update.isPending}
        submitLabel="Salvar alterações"
      />
    </div>
  )
}
